{
  "admin.analytics.heading": "OMA+ analytics",
  "admin.analytics.population.caption": "Usage data from consenting users only. Sent messages are counted for all users.",
  "admin.analytics.backToPortal": "Back",
  "admin.analytics.retry": "Try again",
  "admin.analytics.export": "Export to Excel",
  "admin.analytics.export.pending": "Preparing Excel file…",
  "admin.analytics.export.changed": "The report was refreshed for this export.",
  "admin.analytics.export.failed": "Analytics Excel export failed. Try again.",
  "admin.analytics.export.unavailable": "Analytics Excel export is not available right now.",
  "admin.analytics.loading": "Loading analytics…",
  "admin.analytics.error": "Analytics could not be loaded.",
  "admin.analytics.unavailable.heading": "Analytics is not available yet",
  "admin.analytics.unavailable.body": "Data is not available right now. Please try again later.",
  "admin.analytics.summary.heading": "Usage summary",
  "admin.analytics.metric.visitors": "Distinct visitors",
  "admin.analytics.metric.visits": "Visits",
  "admin.analytics.metric.sentMessages": "Sent messages",
  "admin.analytics.metric.averageActiveSeconds": "Average time in the service",
  "admin.analytics.metric.open": "View details",
  "admin.analytics.comparison.unavailable": "Comparison unavailable",
  "admin.analytics.value.unavailable": "Data not available",
  "admin.analytics.value.partial": "Partial measurement",
  "admin.analytics.samples": "Measured visits: {count}.",
  "admin.analytics.topPages.heading": "Most visited pages",
  "admin.analytics.topPages.empty": "Data not available",
  "admin.analytics.topPages.open": "View all pages",
  "admin.analytics.devices.heading": "Devices",
  "admin.analytics.devices.description": "Shares are based on visits, not users.",
  "admin.analytics.devices.mobile": "Mobile",
  "admin.analytics.devices.tablet": "Tablet",
  "admin.analytics.devices.desktop": "Desktop",
  "admin.analytics.devices.unknown": "Unknown",
  "admin.analytics.coverage.inProgress": "The selected period is still in progress.",
  "admin.analytics.coverage.partial": "Data is available for only part of the selected period.",
  "admin.analytics.coverage.unavailable": "Data is not available for the selected period.",
  "admin.analytics.coverage.referencePartial": "Data is available for only part of the comparison period.",
  "admin.analytics.coverage.referenceUnavailable": "Data is not available for the comparison period.",
  "admin.analytics.coverage.limitation": "Measurement describes stored service use and may not capture all use.",
  "admin.analytics.messages.disclosure": "Sent messages includes only successful contacts started through Oma+ Contact us. Replies are excluded.",
  "admin.analytics.messages.currentPeriod": "Message-counter period: {period}",
  "admin.analytics.messages.referencePeriod": "Message-counter comparison period: {period}",
  "admin.analytics.messages.coverage": "Message-counter coverage: current {current}; comparison {reference}.",
  "admin.analytics.messages.coverage.complete": "complete",
  "admin.analytics.messages.coverage.partial": "partial",
  "admin.analytics.messages.coverage.unavailable": "unavailable",
  "admin.analytics.messages.noReference": "no comparison",
  "admin.analytics.messages.readAt": "Message counter read at {readAt}. Counts are stored by UTC hour; the active hour updates through the read time.",
  "admin.analytics.period.heading": "Period",
  "admin.analytics.period.disclosure": "Month means 30 elapsed days. Six months means 180 elapsed days.",
  "admin.analytics.period.option.last24Hours": "Last 24 h",
  "admin.analytics.period.option.lastWeek": "Last week",
  "admin.analytics.period.option.lastMonth": "Last month",
  "admin.analytics.period.option.lastSixMonths": "Last 6 months",
  "admin.analytics.period.option.all": "All",
  "admin.analytics.period.option.custom": "Choose period",
  "admin.analytics.period.customSelected": "Choose period: {range}",
  "admin.analytics.period.from": "Start date",
  "admin.analytics.period.to": "End date",
  "admin.analytics.period.apply": "Apply dates",
  "admin.analytics.period.cancel": "Cancel",
  "admin.analytics.period.validation.missing": "Enter valid start and end dates.",
  "admin.analytics.period.validation.reversed": "Start date must not be after end date.",
  "admin.analytics.period.validation.future": "Future dates cannot be selected.",
  "admin.analytics.period.selected": "Selected period: {period}",
  "admin.analytics.period.details": "Period details",
  "admin.analytics.period.current": "Selected period",
  "admin.analytics.period.reference": "Comparison period",
  "admin.analytics.period.endExclusive": "The end boundary is excluded.",
  "admin.analytics.period.calendar.selectFromInstruction": "Select a start date from the calendar.",
  "admin.analytics.period.calendar.selectToInstruction": "Select an end date from the calendar.",
  "admin.analytics.period.calendar.fromTo": "Start and end date",
  "admin.analytics.period.calendar.previousMonth": "Previous month",
  "admin.analytics.period.calendar.nextMonth": "Next month",
  "admin.analytics.period.calendar.weekdays": "Mo Tu We Th Fr Sa Su",
  "admin.analytics.detail.heading": "Metric details",
  "admin.analytics.detail.back": "Back",
  "admin.analytics.detail.loading": "Loading metric details…",
  "admin.analytics.detail.error": "Metric details could not be loaded.",
  "admin.analytics.detail.retry": "Retry metric",
  "admin.analytics.detail.unavailable": "Metric details are not available right now.",
  "admin.analytics.detail.changed": "The report changed. Refresh to load new metric details.",
  "admin.analytics.detail.refresh": "Refresh report",
  "admin.analytics.detail.values": "Data table",
  "admin.analytics.detail.cumulative": "Cumulative",
  "admin.analytics.detail.messages.lakikaveri": "Lakikaveri",
  "admin.analytics.detail.messages.jasenasiat": "Member affairs",
  "admin.analytics.detail.messages.total": "Total",
  "admin.analytics.detail.messages.legend": "Legend",
  "admin.analytics.detail.period": "Period",
  "admin.analytics.detail.missing": "Dashed line joins observations around a measurement gap.",
  "admin.analytics.detail.distinctNotAdditive": "Distinct visitors cannot be added across periods because one person can appear in multiple periods.",
  "admin.analytics.detail.visitsNotAdditive": "Visits cannot be added across periods because one visit can appear in multiple periods.",
  "admin.analytics.detail.durationDenominator": "The average uses visits with an observed active-time measurement.",
  "admin.analytics.detail.samples": "Measured visits: {count}.",
  "admin.analytics.pages.heading": "Most visited pages",
  "admin.analytics.pages.loading": "Loading pages…",
  "admin.analytics.pages.error": "Pages could not be loaded.",
  "admin.analytics.pages.retry": "Retry pages",
  "admin.analytics.pages.unavailable": "Page details are not available right now.",
  "admin.analytics.pages.changed": "The report changed. Refresh to load a new page list.",
  "admin.analytics.pages.refresh": "Refresh report",
  "admin.analytics.pages.page": "Page",
  "admin.analytics.pages.views": "Views",
  "admin.analytics.pages.activeTime": "Average time",
  "admin.analytics.pages.documentLoad": "Document load",
  "admin.analytics.pages.routeLoad": "Route load",
  "admin.analytics.pages.samples": "Measured page views: {count}.",
  "admin.analytics.pages.durationDenominator": "Page averages use page views with an observed active-time measurement.",
  "admin.analytics.pages.total": "{count} pages",
  "admin.analytics.pages.next": "Next page",
  "admin.analytics.pages.previous": "Previous page",
  "admin.analytics.unit.count": "count",
  "admin.analytics.unit.seconds": "seconds",
  "admin.analytics.granularity.hour": "Hourly",
  "admin.analytics.granularity.day": "Daily",
  "admin.analytics.granularity.week": "Weekly"
}
